export const steps = [
  // { title: 'Your estate details', description: 'Please enter your estate name and address' },
  {
    title: 'Your details',
    description: 'Please enter your name, phone number and address',
  },
  { title: 'Your password', description: 'Please go ahead to set password' },
]
